<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('carAttendance.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('carAttendance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-tabs target="carAttendanceList">
        <ts-tab>{{ $t('carAttendance.current') }}</ts-tab>
        <ts-tab>{{ $t('carAttendance.history') }}</ts-tab>
      </ts-tabs>
      <ts-tab-panes name="carAttendanceList">
        <ts-tab-pane>
          <current />
        </ts-tab-pane>
        <ts-tab-pane>
          <history />
        </ts-tab-pane>
      </ts-tab-panes>
    </ts-card>
  </div>
</template>

<script>
import Current from './current'
import History from './history'
export default {
  name: 'car-attendance-table',
  components: { Current, History }
}
</script>
